function Accessibility() {
    this.modalEl = null;
    this.triggerEl = null;
    this.fontSizeCookie =  null;
    this.contrastCookie = null;
    this.readspeakerCookie = null;
    this.contrastRadioEls = null;
    this.readspeakerRadioEls = null;

    this.init();
}

Accessibility.prototype.init = function() {
    this.modalEl = document.querySelector('.jsAccessibilityModal');
    this.triggerEl = document.querySelector('.jsAccessibilityTrigger');
    this.fontSizeCookie =  this.getCookie('ab_font_size');
    this.contrastCookie = this.getCookie('ab_contrast');
    this.readspeakerCookie = this.getCookie('ab_readspeaker');

    if (! this.modalEl) return;

    this.contrastRadioEls = this.modalEl.querySelectorAll('input[name="contrast-enabled"]');
    this.readspeakerRadioEls = this.modalEl.querySelectorAll('input[name="readspeaker-enabled"]');

    if (this.fontSizeCookie) document.documentElement.classList.add(this.fontSizeCookie);
    else document.documentElement.classList.add('ab-font-size-0');

    if (this.contrastCookie === 'on') this.enableContrastMode();
    else this.disableContrastMode();

    if (this.contrastCookie === 'on') this.enableContrastMode();
    else this.disableContrastMode();

    if (this.readspeakerCookie === 'on') this.enableReadspeaker();
    else this.disableReadspeaker();

    this.setFontSizeButtons();
    this.addEventListeners();
}

Accessibility.prototype.addEventListeners = function() {

    // TODO: When clicking anywhere outside the modal, hide the modal

    if (this.triggerEl) {
        this.triggerEl.addEventListener('click', e => {
            e.preventDefault();
            this.toggleModal();
        });
    }

    if (this.modalEl) {
        this.modalEl.addEventListener('keydown', e => {
            if ((e.keyCode === 32 || e.keyCode === 13) && e.target.tagName.toLowerCase() === 'label') {
                e.preventDefault();
                const inputEl = e.target.parentElement.querySelector('input');
                inputEl.checked = !inputEl.checked;
            }
        });

        window.addEventListener('keyup', e => {
            if (e.key.toLowerCase() === 'escape') {
                this.hideModal();
            }
        });

        this.modalEl.addEventListener('click', e => {
            if (e.target.classList.contains('jsFontSizeSmaller')) this.makeFontSmaller();
            else if (e.target.classList.contains('jsFontSizeLarger')) this.makeFontBigger();
        });

        this.modalEl.addEventListener('change', e => {
            if (e.target.tagName.toLowerCase() === 'input' && e.target.name === 'contrast-enabled') {
                [...this.contrastRadioEls].map(el => {
                    if (el.checked) {
                        if (parseInt(el.value) === 1) this.enableContrastMode();
                        else if (parseInt(el.value) === 0) this.disableContrastMode();
                    }
                });
            }
            else if (e.target.tagName.toLowerCase() === 'input' && e.target.name === 'readspeaker-enabled') {
                [...this.readspeakerRadioEls].map(el => {
                    if (el.checked) {
                        if (parseInt(el.value) === 1) this.enableReadspeaker();
                        else if (parseInt(el.value) === 0) this.disableReadspeaker();
                    }
                });
            }
        });
    }
}

Accessibility.prototype.setFontSizeButtons = function() {
    this.modalEl.querySelector('.jsFontSizeSmaller').disabled = false;
    this.modalEl.querySelector('.jsFontSizeLarger').disabled = false;

    if (document.documentElement.classList.contains('ab-font-size-0')) this.modalEl.querySelector('.jsFontSizeSmaller').disabled = true;
    else if (document.documentElement.classList.contains('ab-font-size-2')) this.modalEl.querySelector('.jsFontSizeLarger').disabled = true;
}

Accessibility.prototype.toggleModal = function() {
    if (this.modalEl.classList.contains('show')) this.hideModal();
    else this.showModal();
}

Accessibility.prototype.showModal = function() {
    this.modalEl.classList.add('show');
};

Accessibility.prototype.hideModal = function() {
    this.modalEl.classList.remove('show');
};

Accessibility.prototype.makeFontBigger = function() {
    if (document.documentElement.classList.contains('ab-font-size-0')) {
        document.documentElement.classList.remove('ab-font-size-0');
        document.documentElement.classList.add('ab-font-size-1');
        document.cookie = 'ab_font_size=ab-font-size-1';
    }
    else if (document.documentElement.classList.contains('ab-font-size-1')) {
        document.documentElement.classList.remove('ab-font-size-1');
        document.documentElement.classList.add('ab-font-size-2');
        document.cookie = 'ab_font_size=ab-font-size-2';
    }

    this.setFontSizeButtons();
};

Accessibility.prototype.makeFontSmaller = function() {
    if (document.documentElement.classList.contains('ab-font-size-1')) {
        document.documentElement.classList.remove('ab-font-size-1');
        document.documentElement.classList.add('ab-font-size-0');
        document.cookie = 'ab_font_size=ab-font-size-0';
    }
    else if (document.documentElement.classList.contains('ab-font-size-2')) {
        document.documentElement.classList.remove('ab-font-size-2');
        document.documentElement.classList.add('ab-font-size-1');
        document.cookie = 'ab_font_size=ab-font-size-1';
    }

    this.setFontSizeButtons();
};

Accessibility.prototype.enableContrastMode = function() {
    document.documentElement.classList.add('ab-contrast');
    document.cookie = 'ab_contrast=' + 'on';

    [...this.contrastRadioEls].map(el => {
        if (parseInt(el.value) === 1) el.checked = true;
        else el.checked = false;
    });
};

Accessibility.prototype.disableContrastMode = function() {
    document.documentElement.classList.remove('ab-contrast');
    document.cookie = 'ab_contrast=' + 'off';

    [...this.contrastRadioEls].map(el => {
        if (parseInt(el.value) === 0) el.checked = true;
        else el.checked = false;
    });
};

Accessibility.prototype.enableReadspeaker = function() {
    document.documentElement.classList.add('ab-readspeaker');
    document.cookie = 'ab_readspeaker=' + 'on';

    [...this.readspeakerRadioEls].map(el => {
        if (parseInt(el.value) === 1) el.checked = true;
        else el.checked = false;
    });
};

Accessibility.prototype.disableReadspeaker = function() {
    document.documentElement.classList.remove('ab-readspeaker');
    document.cookie = 'ab_readspeaker=' + 'off';

    [...this.readspeakerRadioEls].map(el => {
        if (parseInt(el.value) === 0) el.checked = true;
        else el.checked = false;
    });
};

Accessibility.prototype.getCookie = function(name) {
    const dc = document.cookie;
    const prefix = name + '=';
    let end = '';
    let begin = dc.indexOf('; ' + prefix);

    if (begin === -1) {
        begin = dc.indexOf(prefix);
        if (begin !== 0) return null;
    }
    else {
        begin += 2;
        end = document.cookie.indexOf(";", begin);

        if (end === -1) end = dc.length;
    }

    return decodeURI(dc.substring(begin + prefix.length, end));
}

new Accessibility();
